import { OPS_API_URL } from '../routes/constants';

export const get = async <T>(id?: string): Promise<T> => {
  const response = await fetch(OPS_API_URL(id || 'generic'));
  return response.json();
};
